import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const AiInstructionSection = ({ title, description, instructions = '', onEdit }) => (
  <Box
    border={1}
    borderColor='divider'
    borderRadius={3}
    p={3}
    bgcolor='#fff'
    sx={{ boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }}
  >
    <Box display='flex' alignItems='flex-start' justifyContent='space-between' gap={2} mb={1}>
      <Typography variant='subtitle1' fontWeight={700}>
        {title}
      </Typography>
      <Button
        variant='outlined'
        size='small'
        startIcon={<EditOutlinedIcon />}
        onClick={onEdit}
        sx={{ textTransform: 'none', flexShrink: 0 }}
      >
        Edit instructions
      </Button>
    </Box>
    <Typography variant='body2' color='text.secondary' mb={2.5} sx={{ maxWidth: 820 }}>
      {description}
    </Typography>
    <Typography variant='body2' fontWeight={700} mb={1}>
      Instructions
    </Typography>
    <Box
      sx={{
        bgcolor: '#f8fafc',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        p: 2,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
        fontSize: 13,
        lineHeight: 1.6,
        whiteSpace: 'pre-wrap',
        color: 'text.primary',
        minHeight: 220,
      }}
    >
      {instructions || 'No instructions saved yet.'}
    </Box>
  </Box>
);

export default AiInstructionSection;
